import React, { useState, } from 'react'
 import { getInvoiceDownload } from '../backend-services';

const useDownloadReport = ({reportType, startDate, endDate, onUpdate}: any) => {

const [isLoading, setIsLoading] = useState(false)

const downloadPDF = async () => {
  setIsLoading(true);
  try {
    const response = await getInvoiceDownload( reportType );
    const data = await response.json();
    if (data.pdfUrl) {
      window.open(data.pdfUrl, "_blank");
      const updatedReport = { ...data, pdfUrl: data.pdfUrl };
      onUpdate(updatedReport);
    }
  } catch (error) {
    setIsLoading(false)
    console.error("Error downloading the PDF: ", error);
  } finally {
    setIsLoading(false);
  }
};
  return {
    downloadPDF,
    isLoading
  }
}

export default useDownloadReport